<template>
  <div
    :style="NavbarCustomStyle"
    class="headerContainer px-3 py-1 container-fluid"
  >
    <div
      class="mt-2 collapse navbar-collapse mt-sm-0 me-md-0 me-sm-4"
      id="navbar"
    >
      <NavbarBrand />

      <ul class="nav navbar-nav justify-content-end ms-auto">
        <NavbarSidebarToogler />
        <NavbarProfileButton />
        <NavbarLogoutButton />
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { NavbarBrand } from "../components/exporter.js";
import {
  NavbarSidebarToogler,
  NavbarProfileButton,
  NavbarLogoutButton,
} from "../components/exporter.js";

export default {
  name: "navbar-container",
  components: {
    NavbarBrand,
    NavbarSidebarToogler,
    NavbarProfileButton,
    NavbarLogoutButton,
  },
  computed: {
    ...mapGetters(["getDarkMode"]),
    NavbarCustomStyle() {
      return {
        backgroundColor: this.getDarkMode === false ? "#f9f9f9" : "transparent",
        borderRadius: "10px",
      };
    },
  },
};
</script>
